import Vue from 'vue'
import App from './App.vue'

import vuescroll from 'vuescroll';
// 滚动条组件
Vue.use(vuescroll, {
    ops: {
        rail: {
            size: '5px'
        },
        bar: {
            background: '#cccccc',
            size: '4px',
            opacity: 0.8,
            onlyShowBarOnScroll: false
        }
    }, // 在这里设置全局默认配置
    name: 'vuecroll' // 在这里自定义组件名字，默认是vueScroll
});

import { createRouter } from "./router";

import { createStore } from "@/store";

import './assets/style/dialog.scss'

// 注册-拖拽组件
// import VueDND from 'awe-dnd';
// Vue.use(VueDND);

//引用组件
require('./components')


import md5 from 'js-md5'
Vue.prototype.$md5 = md5;


import ant from 'ant-design-vue';
import 'ant-design-vue/dist/antd.css'

import doitUIWeb from 'doit-ui-web'
import 'doit-ui-web/lib/doituiweb.css'
Vue.use(ant);
Vue.use(doitUIWeb)

import echarts from 'echarts'
import axios from 'axios'


Vue.config.productionTip = false

Vue.prototype.$echarts = echarts;
Vue.prototype.$axios = axios;



// 内容复制到剪贴板
import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)


// 渐进式
import progressive from 'progressive-image/dist/vue'; 
Vue.use(progressive, {
    removePreview: true,
    scale: true
})



// 导出一个工厂函数，用于创建新的
// 应用程序、router 和 store 实例
export function createApp() {
    const router = createRouter();
    const store = createStore();
    const app = new Vue({
        router,
        store,
        // 根实例简单的渲染应用程序组件。
        render: h => h(App)
    })
    return { app, router, store }
}
